import { Skeleton, Typography } from 'antd'
import React, { Suspense } from 'react'

import { Isins } from './Isins/Isins'

export const IsinsPage = () => (
  <>
    <Typography.Title>Isins</Typography.Title>

    <Suspense fallback={<Skeleton />}>
      <Isins />
    </Suspense>
  </>
)
